import type { StudioOptionsResponseDto, StudioVariantDto } from '@lunary/api-client'
import { Select } from '@lunary/ui-web/select'
import styles from './studio.module.css'

type Props = {
  readonly label: string
  readonly value: StudioVariantDto
  readonly options: StudioOptionsResponseDto
  readonly onChange: (next: StudioVariantDto) => void
}

const suffix = (active: boolean) => (active ? ' · сейчас в проде' : '')

export function VariantConfig({ label, value, options, onChange }: Props) {
  return (
    <fieldset className={styles.variantConfig}>
      <legend>{label}</legend>
      <label>
        Модель
        <Select
          aria-label="Модель"
          value={value.model}
          options={options.models.map((m) => ({ value: m, label: `${m}${suffix(m === options.default_model)}`, short: m }))}
          onChange={(m) => onChange({ ...value, model: m })}
        />
      </label>
      <label>
        Персона
        <Select
          aria-label="Персона"
          value={`v${value.persona_version}`}
          options={options.persona_versions.map((v) => ({ value: `v${v}`, label: `v${v}${suffix(v === options.active_persona)}`, short: `v${v}` }))}
          onChange={(v) => onChange({ ...value, persona_version: Number(v.slice(1)) })}
        />
      </label>
      <label>
        Задача «карта дня»
        <Select
          aria-label="Задача «карта дня»"
          value={`v${value.system_version}`}
          options={options.system_versions.map((v) => ({ value: `v${v}`, label: `v${v}${suffix(v === options.active_system)}`, short: `v${v}` }))}
          onChange={(v) => onChange({ ...value, system_version: Number(v.slice(1)) })}
        />
      </label>
    </fieldset>
  )
}
